export default __webpack_public_path__ + "static/spring_road-422394e654d5f3d8ab29ecaa1d1f03bb.png";